import { render, staticRenderFns } from "./DocumentReduceDebt.vue?vue&type=template&id=700f539a&scoped=true&"
import script from "./DocumentReduceDebt.vue?vue&type=script&lang=js&"
export * from "./DocumentReduceDebt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700f539a",
  null
  
)

export default component.exports